module.exports = __webpack_public_path__ + "images/consent_pending_e3a5557.svg";